import React, { useState, FC, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import './ItemSearch.css';

interface ItemSearchProps {
    onSearch: (itemId: string) => void;
    disabled?: boolean;
}

const ItemSearch: FC<ItemSearchProps> = ({ onSearch, disabled }) => {
    const { t } = useTranslation();
    const [itemId, setItemId] = useState('');

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        onSearch(itemId);
    };

    return (
        <form onSubmit={handleSubmit} className="item-search-form">
            <input
                type="text"
                value={itemId}
                onChange={(e) => setItemId(e.target.value)}
                placeholder={t('enterTokenId') || 'Enter Token ID'}
                disabled={disabled}
            />
            <button type="submit" disabled={disabled}>{t('search.button')}</button>
        </form>
    );
};

export default ItemSearch;